import { useState } from "react";
import { mediaUrl } from "../api";
import type { PlacePhoto } from "../types";
import ConfirmRemove from "./ConfirmRemove";
import { SelectField } from "./fields";

type Props = {
  photos: PlacePhoto[];
  busy: boolean;
  onAddFile: (file: File, category: string) => Promise<void>;
  onDelete: (name: string) => void | Promise<void>;
};

export default function PhotosPanel({ photos, busy, onAddFile, onDelete }: Props) {
  const [category, setCategory] = useState("ADDITIONAL");
  const [over, setOver] = useState(false);

  function take(files: FileList | null) {
    const file = files?.[0];
    if (!file) return;
    void onAddFile(file, category);
  }

  return (
    <section className="space-y-5">
      <div className="pr-card space-y-4 p-5">
        <div className="max-w-xs">
          <p className="mb-1 text-xs text-slate-500">Type</p>
          <SelectField
            value={category}
            onChange={setCategory}
            options={[
              { value: "COVER", label: "Couverture" },
              { value: "PROFILE", label: "Profil" },
              { value: "ADDITIONAL", label: "Galerie" },
            ]}
          />
        </div>
        <label
          className={`flex cursor-pointer flex-col items-center justify-center rounded-2xl border border-dashed px-6 py-10 text-center ${
            over ? "border-violet bg-violet/5" : "border-violet/25 bg-mist"
          }`}
          onDragOver={(e) => {
            e.preventDefault();
            setOver(true);
          }}
          onDragLeave={() => setOver(false)}
          onDrop={(e) => {
            e.preventDefault();
            setOver(false);
            take(e.dataTransfer.files);
          }}
        >
          <input
            type="file"
            accept="image/jpeg,image/png,image/webp"
            className="sr-only"
            onChange={(e) => {
              take(e.target.files);
              e.target.value = "";
            }}
          />
          <p className="text-sm font-semibold">{busy ? "Envoi…" : "Déposez une photo, ou cliquez pour la choisir"}</p>
          <p className="mt-1 text-xs text-slate-500">JPEG, PNG ou WebP · 8 Mo max. Envoyée sur la fiche Google.</p>
        </label>
      </div>
      {photos.length === 0 ? (
        <p className="pr-card px-6 py-16 text-center text-sm text-slate-500">Aucune photo sur cette fiche.</p>
      ) : (
        <ul className="grid gap-5 sm:grid-cols-2 xl:grid-cols-3">
          {photos.map((p) => (
            <li key={p.name} className="pr-card overflow-hidden">
              {p.url || p.thumb ? (
                <img src={mediaUrl(p.thumb || p.url)} alt="" loading="lazy" decoding="async" className="h-52 w-full object-cover" />
              ) : (
                <div className="h-52 bg-mist" />
              )}
              <div className="flex flex-wrap items-center justify-between gap-2 px-4 py-3 text-sm">
                <span className="text-slate-500">{p.category === "COVER" ? "Couverture" : p.category === "PROFILE" ? "Profil" : "Galerie"}</span>
                <ConfirmRemove question="Supprimer sur Google ?" confirmLabel="Supprimer" busy={busy} onConfirm={() => onDelete(p.name)} />
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
